import { useTranslation } from 'react-i18next';
import { CircleHelp } from 'lucide-react';
import {
  DialogShellSection,
  EntityCard,
  EntityIcon,
  getUserAvatarUrl,
  getUserFullName
} from '@bliks-io/ui';
import { useProcess } from '@/api/queries/useProcesses';

interface SuccessorUnclearBodyProps {
  processId?: string;
}

export function SuccessorUnclearBody({ processId }: SuccessorUnclearBodyProps) {
  const { t } = useTranslation();
  const { data: processData } = useProcess(processId ?? '');
  const owner = processData?.process?.owner;
  const hasOwner = owner && typeof owner !== 'string';

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-3 rounded-xl border border-line bg-white p-4">
        <EntityIcon icon={<CircleHelp className="h-5 w-5" />} tone="neutral" size={40} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground">
            {t('entityPicker.successor.unclear.cardTitle')}
          </p>
          <p className="mt-1 text-sm text-fg-secondary">
            {t('entityPicker.successor.unclear.cardBody')}
          </p>
        </div>
      </div>

      {hasOwner && (
        <DialogShellSection title={t('entityPicker.successor.unclear.willBeNotified')}>
          <EntityCard
            compact
            person={{
              name: getUserFullName(owner.firstName, owner.lastName),
              role:
                owner.mainRole && typeof owner.mainRole !== 'string'
                  ? owner.mainRole.name
                  : undefined,
              avatarUrl: getUserAvatarUrl(owner, 'thumbnail')
            }}
          />
        </DialogShellSection>
      )}
    </div>
  );
}
